// Pura, testabile senza browser: zippa per INDICE (mai per nome file, due
// sottocartelle di un vault possono contenere file omonimi) i File originali
// di un FormData con l'array di path vault-relativi mandato da useUploadFiles
// come JSON nel campo 'vaultPaths'. Ritorna una Map file -> relativePath|null,
// o null se il campo manca o non è un JSON valido (mai un throw: un
// vaultPaths corrotto non deve far fallire l'upload).
export const resolveVaultPathsByFile = (files, rawVaultPaths) => {
  if (!rawVaultPaths) return null;

  let parsedPaths;
  try {
    parsedPaths = JSON.parse(rawVaultPaths);
  } catch (_) {
    return null;
  }

  if (!Array.isArray(parsedPaths)) return null;

  const vaultPathsByFile = new Map();
  files.forEach((file, index) => {
    vaultPathsByFile.set(file, parsedPaths[index] ?? null);
  });

  return vaultPathsByFile;
};
